import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Login } from 'src/app/models/login';
import { TranslaterService } from 'src/app/services/translater.service';
import { AuthService } from 'src/backend/services/auth.service';
import * as CryptoJS from "crypto-js";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  leftBannerImgurl = 'assets/images/login-banner.png';
  loginForm!: FormGroup;
  translateForm!: FormGroup;
  loginmodel!: Login;
  imageSrc: any = '/assets/images/english.png';
  languageDir = 'ltr';
  langObj: any = {};
  key = CryptoJS.enc.Utf8.parse(Constants.HASH_KEY);
  iv = CryptoJS.enc.Utf8.parse(Constants.HASH_IV);
  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    public translater: TranslaterService,
    public translate: TranslateService,
    private router:Router,
    public authService: AuthService
  ) {
    this.translateForm = this.fb.group({
      languagvalue: [''],
    });
    this.loginForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(4)]],
    });
    this.extractQueryParametersIfExist();
  }

  ngOnInit(): void {
    let currentlang = this.translate.currentLang;
    if (currentlang === 'en') {
      this.imageSrc = '/assets/images/english.png';
    } else if (currentlang === 'ar') {
      this.imageSrc = '/assets/images/arabic.png';
    } else if (currentlang === 'fr') {
      this.imageSrc = '/assets/images/french.png';
    } else if (currentlang === 'sp') {
      this.imageSrc = '/assets/images/spanish.png';
    } else if (currentlang === 'gr') {
      this.imageSrc = '/assets/images/german.png';
    } else if (currentlang === 'du') {
      this.imageSrc = '/assets/images/dutch.png';
    }
    this.translateForm
      .get('languagvalue')
      ?.setValue(currentlang === undefined ? 'en' : currentlang);

    this.getLangWords();  
  }

  extractQueryParametersIfExist() {
    this.activatedRoute.queryParams.subscribe(params => {
      const encryptedParams = params['encrypted'];
      if (encryptedParams) {
        // Decrypt the parameter value
        const decryptedParams = this.decryptObject(encryptedParams, this.key, this.iv);
        // Parse the decrypted data
        if (decryptedParams) {
          this.authService.signInWithUserUsingToken(decryptedParams, false);
        }
      }
    });
  }
  decryptObject(encrypted: string, key: any, iv: any): any {
    const decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv });
    const stringifyData = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(stringifyData);
  }


  changeLang(currentlang) {
    if (currentlang === 'en') {
      this.imageSrc = '/assets/images/english.png';
      this.getLangWords();
      this.languageDir = 'ltr';
    } else if (currentlang === 'ar') {
      this.imageSrc = '/assets/images/arabic.png';
      this.getLangWords();
      this.languageDir = 'rtl';
    } else if (currentlang === 'fr') {
      this.imageSrc = '/assets/images/french.png';
      this.getLangWords();
      this.languageDir = 'ltr';
    } else if (currentlang === 'sp') {
      this.imageSrc = '/assets/images/spanish.png';
      this.getLangWords();
      this.languageDir = 'ltr';
    } else if (currentlang === 'gr') {
      this.imageSrc = '/assets/images/german.png';
      this.getLangWords();
      this.languageDir = 'ltr';
    } else if (currentlang === 'du') {
      this.imageSrc = '/assets/images/dutch.png';
      this.getLangWords();
      this.languageDir = 'ltr';
    }
  }


  public getLangWords() {
    const key = {
      ModuleId: 0,
      PageId: 0,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  login(): void {

    if (this.loginForm.invalid) {
      return;
    }
    const { email, password } = this.loginForm.value;
    const signInInfo = { email, password };
    this.authService.signIn(signInInfo);
    
  }
  resetForm(): void {
    this.loginForm.reset();
  }
}
